import Ajv2020 from "ajv/dist/2020.js";
import { normalizeText, validateTextSource } from "./data-tool-core.js";

export function validateJsonAgainstSchema(dataSource, schemaSource) {
  const dataText = normalizeText(dataSource);
  const schemaText = normalizeText(schemaSource);
  const dataValidation = validateTextSource(dataText, "JSON data");
  if (dataValidation) return { error: dataValidation, valid: false, issues: [] };
  const schemaValidation = validateTextSource(schemaText, "JSON Schema");
  if (schemaValidation) return { error: schemaValidation, valid: false, issues: [] };
  try {
    const data = JSON.parse(dataText);
    const schema = JSON.parse(schemaText);
    const ajv = new Ajv2020({
      allErrors: true,
      strict: true,
      validateFormats: false
    });
    const validate = ajv.compile(schema);
    const valid = Boolean(validate(data));
    return {
      error: "",
      valid,
      issues: valid ? [] : (validate.errors || []).slice(0, 100).map(issue => ({
        path: issue.instancePath || "/",
        keyword: issue.keyword,
        message: issue.message || "does not match the schema"
      })),
      truncated: (validate.errors?.length || 0) > 100
    };
  } catch (error) {
    if (error instanceof SyntaxError) return { error: "JSON data or schema is not valid JSON.", valid: false, issues: [] };
    return { error: `Schema could not be compiled: ${error?.message || "check the schema keywords and references"}.`, valid: false, issues: [] };
  }
}
